import * as Yup from "yup";

const trimRequired = (fieldName: string) =>
  Yup.string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .required(`${fieldName} is Required`)
    .test("not-empty-after-trim", `${fieldName} is Required`, (value) => !!value && value.trim().length > 0);

    const nameRegex = /^[A-Za-z]+$/;
    
const editValidationSchema = Yup.object({
  firstName: trimRequired("First Name").matches(
    nameRegex,
    "First Name is required"
  ),
  LastName: trimRequired("Last Name").matches(
    nameRegex,
    "Last Name is required"
  ),
  dealSource: trimRequired("Deal Source").matches(
    nameRegex,
    "DealSource is required"
  ),
  dealPartner: trimRequired("Deal Partner").matches(
    nameRegex,
    "DealPartner is required"
  ),
  dealCustomer: trimRequired("Deal Customer").matches(
    nameRegex,
    "DealCustomer is required"
  ),
  dealstatus: trimRequired("DealStatus"),
  dealStage: trimRequired("DealStage"),
  opportunityReceivedDate: trimRequired("Opportunity Date"),
  expectedClosureDate: trimRequired("Expected Date"),
  dealTitle: trimRequired("DealTitle"),
  winProbability: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("Win Probability must be a number")
    .required("Win Probability is Required"),
  dealTCV: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("TCV must be a number")
    .required("TCV is Required"),
  dealCurrency: trimRequired("DealCurrency"),
  dealType: trimRequired("DealType"),
  dealDurationMonths: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("Deal Duration Months must be a number")
    .required("Deal Duration Months is Required"),
  lastUpdatedOn: Yup.date()
    .typeError("Invalid date")
    .required("Last Updated On is required"),
  lastUpdateRemarks: trimRequired("Update Remarks"),
});

export default editValidationSchema;
